// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3Bm25","buttons":"styles_buttons__1HWHJ"};